import { useQuery } from "@tanstack/react-query";
import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import { useReportType } from "PFApp/analytics/parts/top_actions_panel/export_wizard_content/use_report_type";
import { fetchExportFields } from "PFCore/services/export_booking";
import { ExportFieldsResponse } from "PFCore/services/export_booking/export_booking.types";

import { fieldsKeys } from "./query_keys";

export const useExportFields = () => {
  const {
    state: {
      data: { frequency }
    }
  } = useAnalyticsModalContext();
  const { reportType } = useReportType();
  const queryKey = fieldsKeys.reportType(reportType, frequency);

  return useQuery<ExportFieldsResponse>(
    queryKey,
    async () => await fetchExportFields({ frequency, reportType })
  );
};
